import Vue from 'vue';
import {DateConf, date02format} from 'razlet-sdk/lib/utils/date';
import { isValidObject } from 'razlet-sdk/lib/utils/helpers';

const MS_IN_DAY = 24 * 60 * 60 * 1000;

function getDateFromAnother(date, days) {
  const d = new Date(date.getTime() + days * MS_IN_DAY);
  d.setHours(0, 0, 0, 0);
  return d;
}

function formatDateToObject(date) {
  return {
    date: String(date.getDate()).padStart(2, 0),
    month: {
      label: DateConf[Vue.prototype.$locale].months[date.getMonth()].full,
      value: String(date.getMonth()+1).padStart(2, 0),
    },
    year: date.getFullYear(),
    isValid: true,
  };
}

function formatDateToString(date) {
  return `${date.getFullYear()}-${date02format(date.getMonth()+1)}-${date02format(date.getDate())}`;
}

function formatObjectToString(date) {
  return `${date.year}-${date.month.value}-${date.date}`;
}

function formatObjectToDate(date) {
  return new Date(`${date.year}-${date.month.value}-${date.date}`);
}

function formatStringToDate(date) {
  return new Date(date);
}

function formatAnythingToDate(day) {
  let date;
  if (day instanceof Date) date = new Date(day);
  if (isValidObject(day)) date = formatObjectToDate(day);
  else date = formatStringToDate(day);
  date.setHours(0, 0, 0, 0);
  return date;
}

function getMonday(date) {
  const newDate = formatAnythingToDate(date);
  const day = newDate.getDay();
  const diffToMonday = day === 0 ? -6 : -day + 1;
  return getDateFromAnother(newDate, diffToMonday);
}

function getSunday(mondayDate) {
  const newDate = formatAnythingToDate(mondayDate);
  return getDateFromAnother(newDate, 6);
}

function isEqual(date1, date2) {
  return formatDateToString(date1) === formatDateToString(date2);
}

export default class {
  dateBasis = null;

  week = {
    from: {},
    to: {},
  };

  weekDates = [];

  from = {
    code: '',
    name: '',
    country: '',
  };

  to = {
    code: '',
    name: '',
    country: '',
  };

  availableDates = [];

  constructor(availableDate = null) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.setDateBasis(getMonday(availableDate || today));

    this.setWeek(this.dateBasis);
  }

  
  get isDirectionsPicked() {
    return this.from && this.from.code && this.to && this.to.code;
  }

  setWeek(day) {
    if (!day) this.week = {
      from: {},
      to: {},
    };

    const monday = getMonday(day);
    const sunday = getSunday(monday);

    this.setWeekDates(monday, sunday);
    
    this.week = {
      from: formatDateToObject(monday),
      to: formatDateToObject(sunday),
    };
  }

  weekChanged(week) {
    const monday = formatAnythingToDate(week.from);
    const sunday = formatAnythingToDate(week.to);

    if (!isEqual(this.dateBasis,monday)) this.setDateBasis(monday);

    this.setWeekDates(monday, sunday);
  }

  setWeekDates(monday, sunday) {
    const mondayDate = formatAnythingToDate(monday);
    const sundayDate = formatAnythingToDate(sunday);

    let start = mondayDate;

    const range = [];
    while (start <= sundayDate) {
      range.push({
        day: date02format(start.getDate()),
        month: date02format(start.getMonth() + 1),
        year: start.getFullYear(),
      });
      start = getDateFromAnother(start, 1);
    }

    this.weekDates = range;
  }

  setDateBasis(day) {
    this.dateBasis = formatAnythingToDate(day);
  }

  prevWeek() {
    const prevWeekBasis = getDateFromAnother(this.dateBasis, -7);
    this.setDateBasis(prevWeekBasis);
  }

  nextWeek() {
    const nextWeekBasis = getDateFromAnother(this.dateBasis, 7);
    this.setDateBasis(nextWeekBasis);
  }

  swapCities() {
    const city = this.from;
    this.from = this.to;
    this.to = city;
  }

  buildDatesRequest() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const begin = formatDateToString(today);
    const end = formatDateToString(getDateFromAnother(this.dateBasis, 340));

    const req = {
      departure: this.from.code,
      arrival: this.to.code,
      begin,
      end,
    };

    return req;
  }

  buildPricesRequest() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = formatDateToString(today);
    const end = formatDateToString(getDateFromAnother(this.dateBasis, 90));

    const req = {
      departure: this.from.code,
      arrival: this.to.code,
      start,
      end,
    };

    return req;
  }

  buildRequest(isFirstAvailable = false) {
    const req = {
      departure: this.from.code,
      arrival: this.to.code,
    };
    if (isFirstAvailable) {
      req.isFirstAvailable = true;
    }
    else {
      req.dateBegin = formatObjectToString(this.week.from);
      req.dateEnd = formatObjectToString(this.week.to);
    }
    return req;
  }
}